import request from '@/api/request'

// 获取客户跟进记录列表
export function getCustomerFollowUps(customerId: number, params?: { page?: number; pageSize?: number; type?: string }) {
  return request({
    url: `/customers/${customerId}/follow-ups`,
    method: 'get',
    params
  })
}

// 添加跟进记录
export function addCustomerFollowUp(customerId: number, data: {
  employeeId: number
  type: 'phone' | 'visit' | 'wechat' | 'email' | 'other'
  content: string
  nextFollowUpDate?: string
  nextPlanContent?: string
  reminderSet?: boolean
}) {
  return request({
    url: `/customers/${customerId}/follow-ups`,
    method: 'post',
    data
  })
}

// 获取跟进记录详情
export function getFollowUpDetail(customerId: number, followUpId: number) {
  return request({
    url: `/customers/${customerId}/follow-ups/${followUpId}`,
    method: 'get'
  })
}

// 更新跟进记录
export function updateFollowUp(customerId: number, followUpId: number, data: {
  type?: string
  content?: string
  nextFollowUpDate?: string
  reminderSet?: boolean
}) {
  return request({
    url: `/customers/${customerId}/follow-ups/${followUpId}`,
    method: 'put',
    data
  })
}

// 删除跟进记录
export function deleteFollowUp(customerId: number, followUpId: number) {
  return request({
    url: `/customers/${customerId}/follow-ups/${followUpId}`,
    method: 'delete'
  })
}

// 获取跟进统计
export function getFollowUpStats(customerId: number) {
  return request({
    url: `/customers/${customerId}/follow-ups/stats`,
    method: 'get'
  })
}
